import { render } from "./AffiliatePage.vue?vue&type=template&id=079c37a0&scoped=true"
import script from "./AffiliatePage.vue?vue&type=script&lang=js"
export * from "./AffiliatePage.vue?vue&type=script&lang=js"

import "./AffiliatePage.vue?vue&type=style&index=0&id=079c37a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079c37a0"]])

export default __exports__